<template>
  <v-dialog
    width="45vw"
    v-model="dialog"
    ref="dialog"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="dialog">
        <v-card-title>
          <v-toolbar
            elevation="0"
            style="background-color: transparent"
            class="d-flex align-center justify-center"
          >
            <v-row align="center" justify="center" dense
              ><span class="text-h4" style="color: #a826e1">{{
                form.id
                  ? "Editar plano de ensino"
                  : "Criar um novo plano de ensino"
              }}</span>
            </v-row>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.format"
                label="Modalidade"
                :items="formats"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.frequency"
                label="Frequência na semana"
                :items="frequencies"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="value"
                label="Valor"
                placeholder="R$"
                :value="value"
                :rules="rules.value"
                :hint="`O valor será de: ${
                  displayValue ?? 'R$'
                } mensais para o plano atual`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="discount"
                label="Desconto"
                placeholder="R$"
                :value="discount"
                :hint="`O desconto aplicado será de: ${
                  displayDiscount ?? 'R$'
                } no valor mensal`"
                :rules="rules.discount"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined color="warning-500" @click="closeDialog"
            >Cancelar</v-btn
          >
          <v-btn
            rounded
            outnlined
            color="secondary-500"
            class="white--text"
            @click="save"
          >
            {{ form.id ? "Salvar" : "Criar" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  name: "PlanDialog",
  mixins: [],
  props: {
    platformFee: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      formats: [
        { text: "Individual", value: 1 },
        { text: "Dupla", value: 2 },
        { text: "Trio", value: 3 },
        { text: "Quarteto", value: 4 },
      ],
      frequencies: [
        { text: "1x na semana", value: 1 },
        { text: "2x na semana", value: 2 },
        { text: "3x na semana", value: 3 },
        { text: "4x na semana", value: 4 },
        { text: "Quinzenal", value: 5 },
      ],
      value: null,
      discount: null,
      displayValue: null,
      displayDiscount: null,
      form: {
        format: null,
        frequency: null,
      },
      rules: {
        value: [
          (v) => (Number(v) || 0) > 0 || "O valor deve ser maior que zero.",
        ],
        discount: [
          (v) => (Number(v) || 0) >= 0 || "O desconto não pode ser negativo.",
          (v) =>
            this.checkPrice(v) ||
            "Desconto não pode ser maior que o valor da mensalidade!",
          (v) =>
            this.checkFinalValue(v) ||
            `O valor final com desconto não pode ser menor que a taxa da plataforma (${this.displayFee}).`,
        ],
      },
    };
  },
  computed: {
    displayFee() {
      return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(this.platformFee) || 0);
    },
  },
  watch: {
    value(price) {
      if (price) {
        this.displayValue = Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(price);
      }
    },
    discount(value) {
      if (value) {
        this.displayDiscount = Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
      }
    },
  },
  mounted() {},
  methods: {
    checkPrice(value) {
      return (Number(value) || 0) <= (Number(this.value) || 0) ? true : false;
    },
    checkFinalValue(value) {
      const finalValue = (Number(this.value) || 0) - (Number(value) || 0);
      return finalValue >= (Number(this.platformFee) || 0);
    },
    openDialog(plan) {
      if (plan) {
        this.form = {
          id: plan.id,
          format: plan.format,
          frequency: plan.frequency,
        };
        this.value = plan.value;
        this.discount = plan.discount;
      }
      this.dialog = true;
    },
    closeDialog() {
      this.value = null;
      this.discount = null;
      this.displayValue = null;
      this.displayDiscount = null;
      this.form = {
        format: null,
        frequency: null,
      };
      this.dialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("savePlan", {
          ...this.form,
          value: Number(this.value),
          discount: Number(this.discount || 0),
        });
      }
    },
  },
};
</script>
<style scoped>
.dialog {
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 32px 0 rgba(70, 81, 228, 0.37);
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>
